const FLASH_OFFER = {
  SUPIX: {
    VIEW: 100040011,
    IAL: 100040012,
  },
};

export default FLASH_OFFER;
